export function Separator() {
  return (
    <span
      data-testid="toolbar-separator"
      className="h-6 border-l border-border-primary"
    />
  );
}
